import { authClient, API } from '../index'

export const getS11MapsAdmin = () => {
  return authClient().get(`${API}/s11-maps/admin`)
}

export const getS11MapByKey = (key) => {
  return authClient().get(`${API}/s11-maps/${key}`)
}

export const updateS11Map = (key, data) => {
  return authClient().put(`${API}/s11-maps/${key}`, data)
}
